
import { defineComponent } from "vue";

const SkeletonNotifications = defineComponent({
  name: "SkeletonNotifications",
});
export default SkeletonNotifications;
